module.exports = __webpack_public_path__ + "static/media/eye.e92d44db.svg";